export const FORMALITIES_BASE_BATH = 'formalites';
export const FORMALITY_LIST = '/formalites/liste';
export const FORMALITY_COMPATIBILITIES = '/formalites/compatibilites';
export const FORMALITY_NEW = '/formalites/ajouter';
export const FORMALITY_SELECTION = '/formalites/selection';
export const SOCIETE_SELECTION = '/formalites/selectionsociete';
export const FORMALITY_RECAP = '/formalites/recap';
